import { createContext, useContext, useEffect, useState } from "react";
import { appContext } from "./appProvider";
import axios from "axios";
import { baseUrl, path } from "../constants";
import {v4} from 'uuid'
import translate from "../i18n";
import { api } from "../api";

export const settingsContext = createContext()

const languages = [
    {
        label: 'English',
        value: 'en'
     },
     {
        label: 'አማርኛ',
        value: 'am'
     },
     {
        label: 'Afan Oromo',
        value: 'oro'
     },
     {
        label: 'ትግረኛ',
        value: 'tig'
     }
]

export default function SettingsProvider(props){
    const [chooseLang, setChooseLang] = useState(!localStorage.getItem('userlang'))
    const [userLang, setUserLang] = useState(localStorage.getItem('userlang') || 'en')
    const [notifications, setNotifications] = useState([])
    const { token } = useContext(appContext)

    const t = (key) => translate(key, userLang)
    const changeLang = (lang) => {
        if(token) {
                api(path.changeLanguage, {
                method: 'post',
                data: {lang}
            })
        }
        setUserLang(lang)
        localStorage.setItem('userlang', lang)
        setChooseLang(false)
    }
    
    useEffect(() => {
        if(token){
            axios(baseUrl + path.getLanguage, {headers: {
                'Authorization': 'Bearer ' + token
            }}).then(response => {
                if(response.data.success){
                    const lang = response.data.lang
                    setUserLang(lang || 'en')
                    if(lang) localStorage.setItem('userlang', lang)
                }
            })
        }
        let lang = localStorage.getItem('userlang')
        if(lang) setUserLang(lang)
    }, [token])

    const addNotification = (type, text) => {
        setNotifications([...notifications, {type, text, id: v4()}])
    }


    return (
        <settingsContext.Provider value={{
            chooseLang,
            setChooseLang,
            t,
            changeLang,
            setUserLang,
            languages,
            userLang,
            notifications,
            setNotifications,
            addNotification
        }}>
            {props.children}
        </settingsContext.Provider>
    )
}